export default "__VITE_ASSET__aAMjTLCq__"